















import { DisplayError, HtmlLink } from "@gemma/typescript-types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { GemmaError } from "@gemma/errors";
import { getDisplayErrors } from "../utils/mixins";

@Component({})
export default class Errors extends Vue {
  @Prop({ type: Array, required: true }) errors!: GemmaError<{ links?: HtmlLink[]; message?: string; isHTML: boolean; fieldName?: string }>[];

  get displayErrors(): DisplayError[] {
    return getDisplayErrors(this.errors);
  }
}
